import * as React from 'react';
import { AppLanguage } from '~/common/enums/enums';
import { PostContent, PostMultilingualLink } from '~/common/types/types';
import {
  TagList,
  AuthorsList,
  Content,
  LanguageNavigator,
} from '~/components/common/common';
import * as styles from './post.module.scss';

type Props = {
  post: PostContent;
  currentLanguage: AppLanguage;
  originalLink: string | null;
};

const Post: React.FC<Props> = ({ post, currentLanguage, originalLink }) => {
  const { htmlContent, info } = post;
  const { authors, tags, title } = info;

  const languages = Object.keys(post.multilingualLink ?? {}) as AppLanguage[];
  const hasLanguages = Boolean(languages.length);

  return (
    <>
      <TagList tags={tags} />
      <h1 className={styles.postMainTitle}>{title}</h1>
      <div className={styles.authorsWrapper}>
        <AuthorsList authors={authors ?? []} />
      </div>
      {hasLanguages && (
        <div className={styles.languageWrapper}>
          <LanguageNavigator
            languages={languages}
            originalLink={originalLink as string}
            currentLanguage={currentLanguage}
            multilingualLink={post.multilingualLink as PostMultilingualLink}
          />
        </div>
      )}
      <Content content={htmlContent} />
    </>
  );
};

export { Post };
